// src/layouts/admin/AdminLayout.js
import Header from './Header';
import Menu from './Menu';
import Footer from './Footer';

const AdminLayout = ({ children }) => (
  <div className="wrapper">
    <Header />
    <Menu />
    <div className="content-wrapper">{children}</div>
    <Footer />
  </div>
);

export default AdminLayout;
